import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	value: string;
	unit: string;
	valueColor: string;
	hint?: string;
};

export const InspirationValueCard: FC<Props> = ({
	label,
	value,
	unit,
	valueColor,
	hint,
}) => {
	const theme = useTheme();

	return (
		<Stack
			bgcolor={theme.palette.surface.muted}
			borderRadius={theme.radii.lg}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
		>
			<Typography variant="button" color={theme.palette.grey[500]}>
				{label}
			</Typography>
			<Typography
				variant="h1"
				color={valueColor}
				tabular
				mt={theme.spacingTokens.xs}
			>
				{value}
				<Typography component="span" variant="bodyMedium" color="inherit" muted>
					{unit}
				</Typography>
			</Typography>
			{hint && (
				<Typography
					variant="hint"
					color={theme.palette.grey[500]}
					mt={theme.spacingTokens.sm}
					relaxed
				>
					{hint}
				</Typography>
			)}
		</Stack>
	);
};
